export default __webpack_public_path__ + "static/IMG_9868.png";